import React from 'react'
import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import "../../../Utils/_assets/sass/call-ticker.scss";
import { AddCallTransfer } from "./AddCallTransfer";
import { AddConference } from "./AddConference";
import { C2CFormWidget } from "./C2CFormWidget";
import { CallConferenceInitiated } from "./CallConferenceInitiated";
import { CallInitiation } from "./CallInitiaition";
import * as CallService from "./CallService";
import { ConferenceCall } from "./ConferenceCall";
import * as constants from "./constants";
import { LiveCall } from "./LiveCall";
import { LiveCallAddCustomer } from "./LiveCallAddCustomer";
import { MergeCall } from "./MergeCall";
import { TransferCompleted } from "./TransferCompleted";
import { TransferIntitiated } from "./TransferIntitiated";
import { DialPad } from './DialPad';
import { useMobileViewport } from '../../util/mobileViewPort';

const style = {
  display: "flex",
  alignItems: "stretch",
  justifyContent: "stretch",
  border: "solid 1px #ddd",
  backgroundColor: "var(--white)",
  zIndex: 1300,
  cursor: 'move',
  width: 400,
  height: 'fit-content'
};

export const C2CWidget = (props) => {
  return (
    <>
      <audio id="remoteAudio"></audio>
      <_C2CWidget />
    </>
  );
};

export const _C2CWidget = (props) => {
  const [x, setX] = useState(10);
  const [y, setY] = useState(80);
  const isMobileView = useMobileViewport();
  const [position, setPosition] = useState({ x: 104, y: 60 });
  let offsetX, offsetY;

  const dispatch = useDispatch();

  const window_state = useSelector((state) => {
    return state.ticker.window_state;
  });

  const view_state = useSelector((state) => {
    return state.ticker.view_state;
  });

  const callEvent = useSelector((state) => {
    return state.ticker.callEvent;
  }, shallowEqual);

  const drag = useSelector((state) => {
    return state.ticker.drag;
  }, shallowEqual);

  const [callFlow, setCallFlow] = useState(null);
  const [ticker_data, setTickerData] = useState(CallService.getTickerState());
  const [customerTo, setCustomerTo] = useState(CallService.getTickerState().customer);

  useEffect(() => {
    if (window_state === constants.C2C_CONSTANTS.WINDOW_STATE_OPENED) {
      setY(window.scrollY + 60);
    }
  }, [window_state]);

  useEffect(() => {
    setTickerData(CallService.getTickerState());
    const setWidget = async () => {
      const cf = await CallService.getCallFlowServiceReadonly(
        callEvent,
        dispatch
      );
      setCallFlow(cf);
      if (cf && cf.state.call_state === constants.CALL_STATES.CALL_HANGUP) {
        dispatch({ type: "Close", payload: {} });
        dispatch({ type: "onCallEvent", payload: {} });
      }
    };
    setWidget();
  }, [callEvent, view_state]);

  const onEvent = (event) => {};

  const onUpdatedCustomer = (customer) => {
    dispatch({
      type: "onCallStateChange",
      payload: {
        customer: { ...customer, name: customer?.phonebook?.name},
        customer_version: CallService.getTickerState().customer_version + 1,
      },
    });
    setCustomerTo(CallService.getTickerState().customer);
  };

  // Calling customer API only when user clicks on, ADD/UPDATE user button.
  useEffect(() => {
    const getCustomer = async () => {
      const test = await CallService.getCustomerApi(CallService.getTickerState().call_customer_number).then(res => {
        if (res && res.data && res.data.objects && res.data.objects.length > 0) {
          setCustomerTo(prev => ({ ...CallService.getTickerState().customer, ...res.data.objects[0] }));
        } else {
          setCustomerTo(prev => ({ ...customerTo, loaded: true, id: null, name: 'Unknown' }));
        }
      });
    };
    if (callFlow && callFlow.state.call_state === constants.CALL_STATES.CALL_INITIATED) setCustomerTo(null);
    if (callFlow && (callFlow.state.call_state === constants.CALL_STATES.CALL_CONNECTED ||
      callFlow.state.call_state === constants.CALL_STATES.CALL_WRAPUP) &&
      view_state === constants.CALL_VIEW_STATES.CALL_ADD_CUSTOMER) getCustomer();
  }, [view_state, callFlow, CallService.getTickerState()])

  var checkIfMobile = window.matchMedia("(max-width: 540px)");
  let isMobile = checkIfMobile.matches;

  const widget = (
    <div
      className="ddc2c_widget widget"
      style={{ width: "100%", height: "100%" }}
    >
      <div
        style={{ width: "100%" }}
        classnamedd="c2c_widget_maindd widget_maindd ctc-bodydd"
      >
        {(!callFlow ||
          !callFlow.state.call_state ||
          callFlow.state.call_state === constants.CALL_STATES.CALL_NONE ||
          callFlow.state.call_state === constants.CALL_STATES.CALL_HANGUP) && (
          <C2CFormWidget onEvent={onEvent} isMobile={isMobile} />
        )}

        {callFlow &&
          (callFlow.state.call_state === constants.CALL_STATES.CALL_CONNECTED ||
            callFlow.state.call_state === constants.CALL_STATES.CALL_WRAPUP) &&
          view_state === constants.CALL_VIEW_STATES.CALL_ADD_CUSTOMER && customerTo && (
            <>
              <LiveCallAddCustomer
                onEvent={onEvent}
                callFlow={callFlow}
                customer={customerTo}
                phone_number={CallService.getTickerState().call_customer_number}
                phone_number_readOnly={true}
                call_id={CallService.getTickerState().callInitialEvent.uuid}
                onUpdated={onUpdatedCustomer}
                isMobile={isMobile}
                moduleName="c2c_ticker"
              />
            </>
          )}
        {callFlow &&
          callFlow.state.call_state ===
            constants.CALL_STATES.CALL_INITIATED && (
            <CallInitiation
              onEvent={onEvent}
              callFlow={callFlow}
              isMobile={isMobile}
            />
          )}

        {callFlow &&
          (callFlow.state.call_state === constants.CALL_STATES.CALL_CONNECTED ||
            callFlow.state.call_state ===
              constants.CALL_STATES.CALL_WRAPUP) && (
            <>
              {view_state === constants.CALL_VIEW_STATES.CALL_VIEW && (
                <LiveCall
                  onEvent={onEvent}
                  callFlow={callFlow}
                  isMobile={isMobile}
                />
              )}
              {view_state == constants.CALL_VIEW_STATES.CALL_DIALPAD &&
                <DialPad onEvent={onEvent} callFlow={callFlow} isMobile={isMobile} />
              } 
              {view_state ===
                constants.CALL_VIEW_STATES.CALL_ADD_CONFERENCE_VIEW && (
                <AddConference
                  onEvent={onEvent}
                  callFlow={callFlow}
                  isMobile={isMobile}
                />
              )}
              {view_state ===
                constants.CALL_VIEW_STATES.CALL_CONFERENCE_INITIATED_VIEW && (
                <CallConferenceInitiated
                  onEvent={onEvent}
                  callFlow={callFlow}
                  isMobile={isMobile}
                />
              )}

              {view_state ===
                constants.CALL_VIEW_STATES.CALL_CONFERENCE_CONNECTED_VIEW && (
                <ConferenceCall
                  onEvent={onEvent}
                  callFlow={callFlow}
                  isMobile={isMobile}
                />
              )}

              {view_state ===
                constants.CALL_VIEW_STATES.CALL_ADD_TRANSFER_VIEW && (
                <AddCallTransfer
                  onEvent={onEvent}
                  callFlow={callFlow}
                  isMobile={isMobile}
                />
              )}

              {view_state ===
                constants.CALL_VIEW_STATES.CALL_TRANSFER_INITIATED_VIEW && (
                <TransferIntitiated
                  onEvent={onEvent}
                  callFlow={callFlow}
                  isMobile={isMobile}
                />
              )}

              {view_state ===
                constants.CALL_VIEW_STATES.CALL_TRANSFER_CONNECTED_VIEW && (
                <MergeCall
                  onEvent={onEvent}
                  callFlow={callFlow}
                  isMobile={isMobile}
                />
              )}

              {view_state ===
                constants.CALL_VIEW_STATES
                  .CALL_TRANSFER_TO_QUEUE_COMPLETED_VIEW && (
                <TransferCompleted
                  onEvent={onEvent}
                  callFlow={callFlow}
                  isMobile={isMobile}
                />
              )}
            </>
          )}
      </div>
      <div className="c2c_widget_footer widget_footer"></div>
    </div>
  );

  const handleDrag = (event) => {
    event.preventDefault();
    const sideNavWidth = isMobileView ? 0 : 104;
    const contentElement = document.getElementById('c2c-dialog-sec');
    const newHeight = contentElement?.offsetHeight ? contentElement?.offsetHeight : 510;
    let newX = event.clientX - offsetX;
    let newY = event.clientY - offsetY;
    newX = Math.max(sideNavWidth, Math.min(newX, window.innerWidth - 400));
    newY = Math.max(0, Math.min(newY, window.innerHeight - newHeight));
    setPosition({ x: newX, y: newY });
  };
  
  const startDrag = (event) => {
    // event.preventDefault();
    offsetX = event.clientX - position.x;
    offsetY = event.clientY - position.y;
    document.addEventListener('mousemove', handleDrag);
    document.addEventListener('mouseup', stopDrag);
  };

  const stopDrag = () => {
    document.removeEventListener('mousemove', handleDrag, { passive: false });
    document.removeEventListener('mouseup', stopDrag);
  };

  return (
    <>
      {!isMobile &&
        window_state === constants.C2C_CONSTANTS.WINDOW_STATE_OPENED && (
          <div className="call-ticker-dialog" 
          onMouseDown={startDrag} 
          style={window_state === constants.C2C_CONSTANTS.WINDOW_STATE_OPENED ? {...style, ...{ left: `${position.x}px`, top: `${position.y}px` }} : { display: "none"  }}
          id="c2c-dialog-sec">
            {widget}
          </div>
        )}

      {!isMobile &&
        window_state === constants.C2C_CONSTANTS.WINDOW_STATE_MINIMIZED && (
          <div className="ticker-window-minimized call-ticker-dialog">
            {" "}
            {widget}
          </div>
        )}
      {isMobile &&
        (window_state === constants.C2C_CONSTANTS.WINDOW_STATE_MINIMIZED ||
          window_state === constants.C2C_CONSTANTS.WINDOW_STATE_OPENED) && (
          <div
            id="c2c-dialog-sec"
            className={
              `call-ticker-dialog mobile-ticker ` +
              (window_state === constants.C2C_CONSTANTS.WINDOW_STATE_MINIMIZED
                ? "ticker-window-minimized"
                : "")
            }
            style={{ backgroundColor: "#fff" }}
            size={{ width: 400, minHeight: 560, height: 'fit-content' }}
          >
            {widget}
          </div>
        )}
    </>
  );
};
